function ErrorComponent() {
  return <div>Unable to load marketplaces</div>;
}

export default ErrorComponent;
